import { ChangeDetectorRef, Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { SystemsExternalCESComponent } from '../crud-ces/crud-ces.component';
import {
  COLUMNS_TO_SHOW_MOBILE,
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from '../crud-config';
import { SystemsExternalService } from '../crud-service';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { FormDataCreate } from '../crud-ces/formDataBuild/form-data-create';
import { getSystemsExternalTypeDescriptionByValue } from 'src/app/domain/registration/enums/system-external-type.enum';
import { ISystemsExternal } from 'src/app/domain/registration/models/ISystemExternal';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PermissionService } from 'src/app/shared/permission.service';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

@Component({
  selector: 'app-systems-external-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemsExternalService],
})
export class SystemsExternalCrudIndex
  extends AbstractCrudIndex<ISystemsExternal>
  implements ITableResponsive
{
  override title = 'SOLUÇÕES EXTERNAS';
  override displayedColumns = COLUMNS_TO_SHOW_WEB;
  override configColumns = TABLE_CONFIG_COLUMNS;

  currentTab: string = 'systems-external'; // Aba atual, por exemplo, 'downloads'
  userType: string = ''; // Tipo de usuário, por exemplo, 'partner'
  public filterFormValues: any = null
  constructor(
    public override dialog: MatDialog,
    public override service: SystemsExternalService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router,
    protected cdr: ChangeDetectorRef,
    protected authService: AuthService, // Apenas na classe atual
    public permissionService: PermissionService,
  ) {
    super(dialog, service, toastService, mediaObserver, router);

    this.userType = this.authService.isPartner() ? 'partner' : 'admin';
    this.currentTab = 'systems-external';

    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_MOBILE
        : COLUMNS_TO_SHOW_WEB;
    });
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  override loadList() {
    let params = this.params;

    this.service.listAll(params).subscribe((dataWithPagination: any) => {
      const [data, length] = dataWithPagination;
      this.length = length;

      this.dataSource = new MatTableDataSource<any>(
        data.map((item: any) => {
          item['type'] = getSystemsExternalTypeDescriptionByValue(item.type);
          item['createdAt'] = moment(item.createdAt).format('DD/MM/YYYY HH:mm');
          return item;
        })
      );
    });
  }

  openShow(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: SystemsExternalCESComponent,
      data: { type: TypeCesEnum.SHOW, element },
      callBack: (data: any) => {
        if (data?.changeType === TypeCesEnum.EDIT) {
          this.openEdit(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }

  openNew(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: SystemsExternalCESComponent,
      data: { type: TypeCesEnum.NEW, element },
      callBack: async (data: any) => {
        if (data?.element) {
          this.service
          .createWithFormData(
            await new FormDataCreate().build({
              ...data.element,
              name: data.element.name.toUpperCase(),
            })
          )
          .subscribe((data: any) => {
            this.loadList();
            this.toastService.showSuccess(MessagesEnum.SUCCESS_CREATED);
          },
          (error) => {
            this.openNew(data.element);
          });
        }
      },
    });
  }

  openEdit(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: SystemsExternalCESComponent,
      data: { type: TypeCesEnum.EDIT, element },
      callBack: async (data: any) => {
        if (data?.element?.id) {
          this.service
            .updateWithFormData(
              data.element.id,
              await new FormDataCreate().build({
                ...data.element,
                name: data.element.name.toUpperCase(),
              })
            )
            .subscribe({
              next: () => {
                this.loadList();
                this.toastService.showSuccess(MessagesEnum.SUCCESS_UPDATED);
              },
              error: (error) => {
                this.openEdit(data.element);
              },
            });
        }
  
        if (data?.changeType === TypeCesEnum.SHOW) {
          this.openShow(element);
        }
  
        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }
  
  public resetFilter(): void {
    this.filterFormValues = null;
    localStorage.removeItem('parcllilterFormValues');

    this.isAdvancedFilterActive = false;
    this.lastAppliedFilter = null;
    this.params = { limit: 25, page: 0, filter: '' };


    const resetFields = this.filterFields.map(field => {
      if (field.type === TypeComponentFieldEnum.SLIDE_TOGGLE) {
        return { ...field, value: false };
      }
      return { ...field, value: '' };
    });

    this.filterFields = resetFields;

    this.loadList();
  }
}
